import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { HemsState } from './hems.state';

export namespace HemsSelectors {
  export const hems = (state: AppState): HemsState => state.hems;

  export const selectHemsGatewaySerialIfNoError = createSelector(
    hems,
    (state: HemsState): string | null => state.gatewaySerial
  );
}
